<template>
  <div class="flex justify-center items-center p-2">
    <img
        alt="..."
        src="@/assets/logo.png"
        class="shadow-lg max-w-xl mr-2"
    />
    <div class="flex flex-col text-center">
      <p class="text-gray-800 font-medium">Jagdamba Education Society's</p>
      <h1 class="text-4xl font-bold pb-1">SND College of Engineering & Research Centre, Babhulgaon, Yeola</h1>
      <p class="text-gray-800 font-medium">Approved by All India Council for Technical Education, New Delhi Affiliated
        to University of Pune, College Code:5124</p>
    </div>
  </div>
  <nav class="p-4 bg-blue-700 text-gray-100">
    <div class="flex md:justify-center items-center">
      <!-- MOBILE NAV ICON -->
      <div class="md:hidden block relative -right-96 fixed">
        <button aria-label="navigation" type="button" @click="toggleNavbar"
                class="md:hidden text-gray-200 transition duration-300 focus:outline-none focus:text-white hover:text-white">
          <i class="fas fa-bars text-3xl" id="bars"></i></button>
      </div>
      <!-- NAVIGATION - LARGE SCREENS -->
      <div class="hidden md:flex">
        <ul class="hidden md:flex">
          <li class="text-lg">
            <a href="" class="nav-link" style="text-underline-offset: 8px;">Home</a></li>
          <li class="text-lg dropdown">
            <a href="" class="nav-link" style="text-underline-offset: 8px;">About <i class="fas fa-angle-down pt-1"></i>
            </a>
            <ul class="dropdown-menu">
              <li class="menu-item"
                  v-for="(about,index) in Abouts"
                  :key="index">
                <router-link :to="about.slug">{{ about.name }}</router-link>
              </li>
            </ul>
          </li>
          <li class="text-lg dropdown">
            <a href="" class="nav-link" style="text-underline-offset: 8px;">Academics <i
                class="fas fa-angle-down pt-1"></i>
            </a>
            <ul class="dropdown-menu">
              <div class="grid grid-cols-3 divide-x divide-gray-200 gap-x-14 text-center">
                <div class="pl-8">
                  <li class="menu-item">
                    <router-link to="/academics/computer/about">Computer Engineering</router-link>
                  </li>
                  <li class="menu-item">
                    <router-link to="/academics/civil/about">Civil Engineering</router-link>
                  </li>
                  <li class="menu-item">
                    <router-link to="/academics/electrical/about">Electrical Engineering</router-link>
                  </li>
                </div>
                <div class="pl-8">
                  <li class="menu-item">
                    <router-link to="/academics/it/about">Information Technology</router-link>
                  </li>
                  <li class="menu-item">
                    <router-link to="/academics/mechanical/about">Mechanical Engineering</router-link>
                  </li>
                  <li class="menu-item">
                    <router-link to="/library/about">Library</router-link>
                  </li>
                </div>
                <div class="pl-8">
                  <li class="menu-item">
                    <router-link to="/academics/science/about">First Year Engineering</router-link>
                  </li>
                  <li class="menu-item">
                    <router-link to="/academics/mba/about">MBA</router-link>
                  </li>
                </div>
              </div>
            </ul>
          </li>
          <li class="text-lg dropdown">
            <a href="" class="nav-link" style="text-underline-offset: 8px;">Admissions <i
                class="fas fa-angle-down pt-1"></i>
            </a>
            <ul class="dropdown-menu">
              <li class="menu-item">
                <router-link to="/admissions/fe">First Year Engineering-UG</router-link>
              </li>
              <li class="menu-item">
                <router-link to="/admissions/dsy">Direct Second Year Engineering-UG</router-link>
              </li>
              <li class="menu-item">
                <router-link to="/admissions/pg">Post Graduation-ME</router-link>
              </li>
              <li class="menu-item">
                <router-link to="/admissions/mba">MBA</router-link>
              </li>
              <li class="menu-item">
                <router-link to="">Admissions Brochure</router-link>
              </li>
              <li class="menu-item">
                <router-link to="">FAQs</router-link>
              </li>
            </ul>
          </li>
          <li class="text-lg">
            <router-link class="nav-link" to="/administration">Administration</router-link>
          </li>

          <li class="text-lg">
            <router-link class="nav-link" to="/tpo/about">Training & Placement</router-link>
          </li>

          <li class="text-lg">
            <router-link class="nav-link" to="/alumni">Alumni</router-link>
          </li>
          <li class="text-lg">
            <router-link class="nav-link" to="/facilities/facility">Facilities</router-link>
          </li>
          <li class="text-lg">
            <a href="" class="nav-link" style="text-underline-offset: 8px;">News & Events</a></li>

          <li class="text-lg">
            <router-link class="nav-link" to="/contact-us">Contact Us</router-link>
          </li>

        </ul>
      </div>
    </div>
    <!-- MOBILE MENU -->
    <div id="mobileMenu" class="flex w-full mx-auto py-8 text-center" :class="{hidden:!showMenu}">
      <div class="flex flex-col justify-center items-center w-full">
        <a href="#"
           class="block text-gray-200 cursor-pointer py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500"
           style="text-underline-offset: 8px;">Home</a>
        <a href="#"
           class="block text-gray-200 cursor-pointer mt-1 py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500"
           style="text-underline-offset: 8px;">About</a>
        <a href="#"
           class="block text-gray-200 cursor-pointer mt-1 py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500"
           style="text-underline-offset: 8px;">Blog</a>
        <a href="#"
           class="block text-gray-200 cursor-pointer mt-1 py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500"
           style="text-underline-offset: 8px;">Contact</a>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      showMenu: false,
      Abouts: [
        {slug: '/about', name: 'About Institute'},
        {slug: '/vision-mission', name: 'Vision & Mission'},
        {slug: '/principal-desk', name: 'Principal Desk'},
        {slug: '/secretary-message', name: "Secretary's Message"},
        {slug: '/governing-body', name: 'Governing Body'},
        {slug: '/grievance-redressal', name: 'Grievance Redressal'},
        {slug: '/governance', name: 'Governance'},
      ],
    }
  },
  methods: {
    toggleNavbar: function () {
      this.showMenu = !this.showMenu;
    }
  }
}
</script>
